module.exports = __webpack_public_path__ + "static/media/sports_30.48bd8e1c.jpg";